import * as actions from '../insurancesActions';

const initialState = {
  insurances: [],
};

const updateInsurances = (state, payload) => {
  state = Object.assign({}, state, {
    insurances: payload,
  });

  return state;
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.UPDATE_INSURANCES:
      return updateInsurances(state, payload);
  }
  return state;
};
